import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import GetIcon from "../../../../utils/Icon";
import Tab1 from "./Tab1";
import printerimg from "../../../../assets/print.png";
import { useGetItemDetailsDataMutation } from "../../../../store/api/itemapi";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Button from "../../../../Core/Button/Button";
import FormLayoutTwo from "../../../../Core/Layout/FormLayoutTwo";
import FileAttachmentManagerViewPage from "../../../../Components/FileAttachmentManagerViewPage";
import Attachment from "../../../../utils/Attachment";
const ViewForm = () => {
  const location = useLocation();
  const IdData = location.state?.ItemId;
  const [podata, setpodata] = useState('')
  // console.log('ids:',IdData)
  const navigate = useNavigate();
  const [tab, settab] = useState(1);
  const [podate, setpodate] = useState(new Date().toISOString().split("T")[0]);
  const [error, setError] = useState("");
  const [ptype, setptype] = useState("Error");
  const [finalstep, setfinalstep] = useState(false);
  const [showError, setShowError] = useState(false);



  // tab1
  const [Item_Code_list, setItem_Code_list] = useState([]);
  const [select_Item_Code, setselect_Item_Code] = useState("");
  const [ItemName, setItemName] = useState("");
  const [ItemDescription, setItemDescription] = useState("");
  const [Item_UOM_list, setItem_UOM_list] = useState([]);
  const [select_Item_UOM, setselect_Item_UOM] = useState("");
  const [PackingUnit, setPackingUnit] = useState("");
  const [PriceList, setPriceList] = useState("");
  const [Customer_list, setCustomer_list] = useState([]);
  const [select_Customer, setselect_Customer] = useState("");
  const [Supplier_list, setSupplier_list] = useState([]);
  const [select_Supplier, setselect_Supplier] = useState("");
  const [BatchNo_list, setBatchNo_list] = useState([]);
  const [select_BatchNo, setselect_BatchNo] = useState("");
  const [Currency, setCurrency] = useState("INR");
  const [Rate, setRate] = useState("");
  const [ValidFrom, setValidFrom] = useState("");
  const [ValidUpto, setValidUpto] = useState("");
  const [LeadTimeindays, setLeadTimeindays] = useState("");
  const [Note, setNote] = useState("");
  const [Reference, setReference] = useState("");

  const [po_response, setpo_response] = useState("");

  const [fieldErrors, setFieldErrors] = useState({
    Item_Code: false,
    Item_UOM: false,
    PriceList: false,
    Rate: false,
  });
  const [itemDetails, { data, isLoadin }] = useGetItemDetailsDataMutation();
  const [AttachmentsList, setAttachmentsList] = useState([]); // ✅ Make sure it's an array
  useEffect(() => {
    if (IdData) {
      itemDetails({ doctype: 'Item Price', name: IdData })
        .unwrap()
        .then((response) => {
          const item = response.docs?.[0]; // ✅ safely access first item
          const docinfo = response.docinfo;

          if (!item) return;
          setpodata(response)
          // console.log(item, "Api response");
         setselect_Item_Code(item.item_code);
                    setItemName(item.item_name);
                    setItemDescription(item.item_description);
                    setselect_Item_UOM(item.uom)
                    setPackingUnit(item.packing_unit)
                    setPriceList(item.price_list)
                    setselect_Customer(item.customer)
                    setselect_Supplier(item.supplier)
                    setselect_BatchNo(item.batch_no)
                    setCurrency(item.currency)
                    setRate(item.price_list_rate)
                    setValidFrom(item.valid_from)
                    setValidUpto(item.valid_upto)
                    setLeadTimeindays(item.lead_time_days)
                    setNote(item.note)
                    setReference(item.reference)
          setAttachmentsList(docinfo.attachments); // ✅ Correct place

        })
        .catch((err) => {
          console.error('API Error:', err);
        });
    } else {
      console.warn('No Id Data found in location state');
    }
  }, [IdData, itemDetails]);

  return (
    <FormLayoutTwo
      title="View Item Price"
      breadcrumbs={[
        { label: "Item Price" },
        { label: "Item Price List", url: "/master/item-price/item-price-list" },
      ]}
      status={'hide'}
      finalStep={finalstep}
      actionButtons={
        <>
          {/* <Button
            to="/master/item-price/item-price-list"
            className="createbtn d-flex"
            style={{ gap: "2px", height: "28px" }}
            iconName="GrFormPrevious"
            iconSize={12}
          >
            Back
          </Button> */}

          <Button
            to="/"
            className="px-2"
            imgSrc={printerimg}
            imgStyle={{ width: "21px" }}
          />
        </>
      }
    >
      <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff", flexGrow: '1' }}>
        <div className="col-12 p-0" style={{ backgroundColor: "#eff4f9" }}>
          <div className="d-flex justify-content-between align-items-end ">
            <ul
              className="nav nav-tabs"
              style={{ color: "white", border: "none" }}
            >
              <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                <a
                  className={
                    tab == 1
                      ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                      : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                  }
                  onClick={() => {
                    settab(1);
                  }}
                  href="javascript:void(0);"
                >
                  General Details
                  {tab == 1 ? (
                    <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                  ) : (
                    <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                  )}
                </a>
              </li>
            </ul>

            <Attachment doctype="Item Price" docname={IdData} />

          </div>
        </div>

        
            <div className=" " style={{ background: '' }}>
          <div className="row">
            <div className="col-12">

                  <Tab1
                    IdData={IdData}
                    Item_Code={{ Item_Code_list: Item_Code_list, setselect_Item_Code: setselect_Item_Code, select_Item_Code: select_Item_Code, Error: fieldErrors.Item_Code }}
ItemName={{
                      ItemName: ItemName,
                      setItemName: setItemName,
                      ItemName: ItemName,
                      Error: fieldErrors.ItemName,
                    }}
                    ItemDescription={{
                      ItemDescription: ItemDescription,
                      setItemDescription: setItemDescription,
                      ItemDescription: ItemDescription,
                      Error: fieldErrors.ItemDescription,
                    }}
                    Item_UOM={{ Item_UOM_list: Item_UOM_list, setselect_Item_UOM: setselect_Item_UOM, select_Item_UOM: select_Item_UOM, Error: fieldErrors.Item_UOM }}
                    PackingUnit={{
                      PackingUnit: PackingUnit,
                      setPackingUnit: setPackingUnit,
                      PackingUnit: PackingUnit,
                      Error: fieldErrors.PackingUnit,
                    }}
                    PriceList={{
                      PriceList: PriceList,
                      setPriceList: setPriceList,
                      PriceList: PriceList,
                      Error: fieldErrors.PriceList,
                    }}
                    Customer={{ Customer_list: Customer_list, setselect_Customer: setselect_Customer, select_Customer: select_Customer, Error: fieldErrors.Customer }}
                    BatchNo={{ BatchNo_list: BatchNo_list, setselect_BatchNo: setselect_BatchNo, select_BatchNo: select_BatchNo, Error: fieldErrors.BatchNo }}
                    Supplier={{ Supplier_list: Supplier_list, setselect_Supplier: setselect_Supplier, select_Supplier: select_Supplier, Error: fieldErrors.Supplier }}
                    Currency={{
                      Currency: Currency,
                      setCurrency: setCurrency,
                      Currency: Currency,
                      Error: fieldErrors.Currency,
                    }}
                    Rate={{
                      Rate: Rate,
                      setRate: setRate,
                      Rate: Rate,
                      Error: fieldErrors.Rate,
                    }}
                    ValidFrom={{
                      ValidFrom: ValidFrom,
                      setValidFrom: setValidFrom,
                      ValidFrom: ValidFrom,
                      Error: fieldErrors.ValidFrom,
                    }}
                    ValidUpto={{
                      ValidUpto: ValidUpto,
                      setValidUpto: setValidUpto,
                      ValidUpto: ValidUpto,
                      Error: fieldErrors.ValidUpto,
                    }}
                    LeadTimeindays={{
                      LeadTimeindays: LeadTimeindays,
                      setLeadTimeindays: setLeadTimeindays,
                      LeadTimeindays: LeadTimeindays,
                      Error: fieldErrors.LeadTimeindays,
                    }}
                    Note={{
                      Note: Note,
                      setNote: setNote,
                      Note: Note,
                      Error: fieldErrors.Note,
                    }}
                    Reference={{
                      Reference: Reference,
                      setReference: setReference,
                      Reference: Reference,
                      Error: fieldErrors.Reference,
                    }}
                  />
                </div>
              </div>
            </div>
      </div>

      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </FormLayoutTwo>
  );
};

export default ViewForm;
